(() => {
  const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
  if (mediaQuery.matches) return;

  const root = document.documentElement;
  root.classList.add("easychoo-motion");

  const sections = Array.from(document.querySelectorAll(".shopify-section"));
  sections.forEach((section, index) => {
    section.style.setProperty("--easychoo-section-index", Math.min(index, 6));
  });

  const revealSection = (section) => {
    section.classList.add("easychoo-in-view");
  };

  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          revealSection(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: "0px 0px -12% 0px", threshold: 0.12 }
    );

    sections.forEach((section) => {
      if (
        section.classList.contains("shopify-section-group-header-group") ||
        section.classList.contains("shopify-section-group-footer-group")
      ) {
        revealSection(section);
        return;
      }
      observer.observe(section);
    });
  } else {
    sections.forEach(revealSection);
  }

  document.querySelectorAll(".hero-slide__content").forEach((content) => {
    Array.from(content.children).forEach((child, index) => {
      child.style.setProperty("--easychoo-hero-item", index);
    });
  });

  const heroes = Array.from(document.querySelectorAll(".hero"));
  if (!heroes.length) return;

  let ticking = false;
  const updateHeroDepth = () => {
    ticking = false;
    if (window.innerWidth < 990) {
      heroes.forEach((hero) => hero.style.setProperty("--easychoo-hero-y", "0px"));
      return;
    }

    heroes.forEach((hero) => {
      const rect = hero.getBoundingClientRect();
      const viewport = window.innerHeight || document.documentElement.clientHeight;
      if (rect.bottom < 0 || rect.top > viewport) return;
      const progress = Math.max(-1, Math.min(1, (viewport / 2 - rect.top) / viewport));
      hero.style.setProperty("--easychoo-hero-y", `${Math.round(progress * 18)}px`);
    });
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateHeroDepth);
  };

  updateHeroDepth();
  window.addEventListener("scroll", requestUpdate, { passive: true });
  window.addEventListener("resize", requestUpdate, { passive: true });
})();
